import {
  Activity,
  BarChart3,
  CandlestickChart,
  ChartArea,
  LineChart,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ChartTypeValue } from "@/lib/lytick/chart-config";

export const CHART_TYPE_ICON: Record<ChartTypeValue, LucideIcon> = {
  candle_solid:       CandlestickChart,
  candle_stroke:      CandlestickChart,
  candle_heikin_ashi: Activity,
  line:               LineChart,
  area:               ChartArea,
  ohlc:               BarChart3,
};
